import { render, staticRenderFns } from "./ScrollableContainerV2.vue?vue&type=template&id=52ed4efc&scoped=true"
import script from "./ScrollableContainerV2.vue?vue&type=script&lang=ts"
export * from "./ScrollableContainerV2.vue?vue&type=script&lang=ts"
import style0 from "./ScrollableContainerV2.vue?vue&type=style&index=0&id=52ed4efc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed4efc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ed4efc')) {
      api.createRecord('52ed4efc', component.options)
    } else {
      api.reload('52ed4efc', component.options)
    }
    module.hot.accept("./ScrollableContainerV2.vue?vue&type=template&id=52ed4efc&scoped=true", function () {
      api.rerender('52ed4efc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ScrollableContainerV2.vue"
export default component.exports